export default {
  API_KEY_CREATED: 'API_KEY_CREATED',
  API_KEY_CREATION_FAILED: 'API_KEY_CREATION_FAILED',
  API_KEY_REMOVED: 'API_KEY_REMOVED',
  API_KEY_REMOVAL_FAILED: 'API_KEY_REMOVAL_FAILED',
  CONFIRMATION_MODAL_NAME: 'api-key-created',
};
